module.exports = __webpack_public_path__ + "static/media/mail.1c0642de.svg";